export default [
	//产品定义[列表]
	{
		path: 'product',
		name: 'm_product',
		meta: {
			templateManage: {
				workType: 7,
				print: 'b_product_printtemplate',
				export: 'b_product_exporttemplate'
			},
			appView: {
				viewId: '90009',
				auth: 'b_product_viewmanage'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/product_list')
	},
	//物料清单[列表]
	{
		path: 'materials',
		name: 'm_material',
		meta: {
			templateManage: {
				workType: 15,
				export: 'b_material_exporttemplate'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/product_material_list.vue')
	},
	//单位列表
	{
		path: 'unit',
		name: 'm_unit',
		props: route => route.params,
		component: () => import('@/pages/basic/dic_unit_list')
	},
	//不良品项列表
	{
		path: 'defects',
		name: 'm_defects',
		props: route => route.params,
		component: () => import('@/pages/basic/dic_defects_list')
	},
	//工序列表
	{
		path: 'process',
		name: 'm_process',
		meta: {
			templateManage: {
				workType: 9,
				print: 'b_process_printtemplate',
				export: 'b_process_exporttemplate'
			},
			// appView: {
			// 	viewId: '90011',
			// 	auth: 'b_process_viewmanage'
			// }
		},
		props: route => route.params,
		component: () => import('@/pages/basic/dic_process_list')
	},
	//仓库列表
	{
		path: 'warehouse',
		name: 'm_warehouse',
		meta: {
			templateManage: {
				workType: 26,
				print: 'b_warehouse_printtemplate',
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/warehouse_list')
	},
	//供应商列表
	{
		path: 'supplier',
		name: 'm_supplier',
		meta: {
			templateManage: {
				workType: 12,
				export: 'b_supplier_exporttemplate'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/supplier_list')
	},
	//客户列表
	{
		path: 'customer',
		name: 'm_customer',
		meta: {
			templateManage: {
				workType: 11,
				export: 'b_customer_exporttemplate'
			},
			appView: {
				viewId: '90034',
				auth: 'b_product_viewmanage'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/customer_list')
	},
	//工艺路线列表
	{
		path: 'process/route',
		name: 'm_processroute',
		meta: {
			templateManage: {
				workType: 10,
				export: 'b_processroute_exporttemplate'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/process_route_list')
	},
	//绩效工资配置
	{
		path: 'salary/config',
		name: 'm_salary_match_config',
		props: route => route.params,
		component: () => import('@/pages/basic/salary_match_config')
	}
];